import { render, staticRenderFns } from "./VenueHireDetailsEdit.vue?vue&type=template&id=3af132e0&scoped=true&"
import script from "./VenueHireDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./VenueHireDetailsEdit.vue?vue&type=script&lang=js&"
import style0 from "./VenueHireDetailsEdit.vue?vue&type=style&index=0&id=3af132e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af132e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VApp,VCard,VCol,VImg,VRow,VSpacer,VSwitch})
